export const SET_ALBUM_DATA = 'habitat/SET_ALBUM_DATA';
export const APPEND_ALBUM_DATA = 'habitat/APPEND_ALBUM_DATA';
export const UPDATE_HABITAT_ALBUM_DATA = 'habitat/UPDATE_HABITAT_ALBUM_DATA';
export const CHANGE_CONTENT_VISIBILITY = 'habitat/CHANGE_CONTENT_VISIBILITY';
export const REMOVE_MEDIA_FROM_ALBUM = 'habitat/REMOVE_MEDIA_FROM_ALBUM';

export const PHOTOS = 'photos';
export const PAST_TALKS = 'pastTalks';
export const CLIPS = 'clips';
export const STREAMS = 'streams';
